import SelectBox from "components/Common/SelectBox"
import { getPaymentMethods } from "helpers/order_edit_resource"
import moment from "moment"
import React, { useEffect, useState } from "react"
import Flatpickr from "react-flatpickr"
import { Button, Col, Input, Label, Row, Table } from "reactstrap"

export default function FormPayment({ form, setForm }) {
  const [paymentDate, setPaymentDate] = useState("")
  const [paymentMethodId, setPaymentMethodId] = useState("")
  const [amount, setAmount] = useState("")
  const [paymentMethods, setPaymentMethods] = useState([])

  const loadPaymentMethods = async () => {
    const res = await getPaymentMethods()
    const _paymentMethods = res.data.map(meth => ({
      value: meth.id,
      label: meth.name,
    }))
    setPaymentMethods(_paymentMethods)
  }

  useEffect(() => {
    loadPaymentMethods()
  }, [])

  const onSubmit = () => {
    if (paymentDate !== "" && paymentMethodId !== "" && amount !== "") {
      const temp = { ...form }
      temp.payments.push({
        paymentDate: moment(paymentDate).format("YYYY-MM-DD"),
        paymentMethodId: paymentMethodId?.value,
        paymentMethodName: paymentMethodId?.label,
        amount: Number(amount),
        id: temp.payments.length + 1,
      })
      setPaymentDate("")
      setPaymentMethodId("")
      setAmount("")
      setForm(temp)
    }
  }

  return (
    <div>
      <Row className="d-flex justify-content-center align-items-center mt-2">
        <Col md={3}>
          <Label>日付</Label>
        </Col>
        <Col md={9}>
          <Flatpickr
            className="form-control d-block"
            placeholder={""}
            value={paymentDate}
            options={{
              dateFormat: "Y-m-d",
            }}
            onChange={date => setPaymentDate(date[0])}
          />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center align-items-center mt-2">
        <Col md={3}>
          <Label>入金方法</Label>
        </Col>
        <Col md={9}>
          <SelectBox
            options={paymentMethods}
            onChange={value => setPaymentMethodId(value)}
            value={paymentMethodId}
          />
        </Col>
      </Row>
      <Row className="d-flex align-items-center mt-2">
        <Col md={3}>
          <Label>入金金額</Label>
        </Col>
        <Col md={6}>
          <Input
            type="number"
            className="form-control"
            onChange={({ target: { value } }) => setAmount(value)}
            value={amount}
          />
        </Col>
        <Col md={3}>
          <Button
            style={{ width: "100%" }}
            color="primary"
            onClick={() => onSubmit()}
          >
            登録
          </Button>
        </Col>
      </Row>

      <Table bordered className="mt-4">
        <thead>
          <tr>
            <th>日付</th>
            <th>入金方法</th>
            <th>金額</th>
          </tr>
        </thead>
        <tbody>
          {form.payments.length ? (
            form.payments.map((payment, index) => (
              <tr key={index}>
                <td>{moment(payment.paymentDate).format("yyyy-MM-DD")}</td>
                <td>{payment.paymentMethodName}</td>
                <td>{payment.amount}</td>
              </tr>
            ))
          ) : (
            <tr />
          )}
        </tbody>
      </Table>
    </div>
  )
}
